import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { 
  Icon,
  IconButton,
  Box
 } from '@material-ui/core';
import { useSnackbar, SnackbarProvider, SnackbarKey } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import {injectIntl, FormattedMessage} from 'react-intl';
import GlobalActions from 'stores/global/actions';
import { useTheme, Theme, withStyles, createTheme, ThemeProvider} from '@material-ui/core/styles';
import BasicTheme from 'themes'; 


export type SnackbarProps = {
  configName?:string;
  themeName?:string;
  options?:SnackbarOptions;
  previewTheme?: Theme
}

export type SnackbarOptions = {
  visible?: boolean;
  close?: boolean;
  variant:'default' | 'success' | 'error' | 'warning' | 'info';
  anchorOrigin?: {
    vertical:'bottom' | 'top'
    horizontal:'left' | 'center' | 'right'
  } | undefined,
  icon?:string;
  content?:React.ReactNode | string | undefined;
  snackbarComponent?: React.ReactNode | undefined;
  action?:React.ReactNode | undefined;
  persist?:boolean;
  preventDuplicate?:boolean;
  hideIconVariant?:boolean;
  dense?:boolean;
  autoHideDuration?:number
}

interface LBSnackbarContentProps extends SnackbarProps {
  config:any;
}

const SnackbarProviderCustom = withStyles((theme:Theme) => {
  return {
    contentRoot: {
      backgroundColor: theme.palette.default.main,
      color: theme.palette.default.contrastText
    },
    variantSuccess: {
      backgroundColor: theme.palette.success.main
    },
    variantError: {
      backgroundColor: theme.palette.error.main
    },
    variantWarning: {
      backgroundColor: theme.palette.warning.main
    },
    variantInfo: {
      backgroundColor: theme.palette.info.main
    }
  }
})(SnackbarProvider);

const VariantIcon = {
  default: '',
  success: 'check_circle',
  info: 'info',
  warning: 'error',
  error: 'cancel'
}

const LBSnackbarContent = (props:LBSnackbarContentProps) => {
  const { options, config } = props;
  const [isOpen, setOpen] = useState(false)
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const global = useSelector( (state:any) => state.global);
  const theme = useTheme();
  const snackbarSetting:SnackbarOptions = options || global.snackbar;

  const onClickDismiss = (key:SnackbarKey) => () => { 
    closeSnackbar(key)
  }

  useEffect(() => {
    if(snackbarSetting.visible && !snackbarSetting.preventDuplicate || (snackbarSetting.preventDuplicate && !isOpen)) {
      setOpen(true)
      enqueueSnackbar(
        <Box display="flex" alignItems="center" justifyContent="space-between" >
          <Box display="flex">
            {
              !snackbarSetting.hideIconVariant && (snackbarSetting.icon || VariantIcon[snackbarSetting.variant]) &&
              <Box color={!snackbarSetting.variant || snackbarSetting.variant === 'default' || !config.onlyUseDefaultBackground ? config.contentColor : theme.palette[snackbarSetting.variant].main} display="flex" mr={1}>
                <Icon fontSize="small">{snackbarSetting.icon || VariantIcon[snackbarSetting.variant]}</Icon>
              </Box>
            }
            <Box color={config.contentColor}>
              {
                typeof snackbarSetting.content === 'object' && snackbarSetting.content
              }
              {
                typeof snackbarSetting.content === 'function' && <snackbarSetting.content />
              }
              {
                typeof snackbarSetting.content === 'string' && <Box whiteSpace="pre-line"><FormattedMessage id={snackbarSetting.content} /></Box>
              }
            </Box>
          </Box>
        </Box>,{
        variant: config.onlyUseDefaultBackground ? 'default' : snackbarSetting.variant,
        anchorOrigin: snackbarSetting.anchorOrigin || config.anchorOrigin || {vertical: 'bottom', horizontal: 'left'},
        persist: snackbarSetting.persist,
        preventDuplicate: snackbarSetting.preventDuplicate,
        content: snackbarSetting.snackbarComponent,
        autoHideDuration: snackbarSetting.autoHideDuration || config.autoHideDuration || 3000,
        action: snackbarSetting.action || snackbarSetting.close && function(key) {
          return (
            <Box color={config.contentColor}><IconButton onClick={onClickDismiss(key)} color="inherit">
              <Icon fontSize="small">close</Icon>
            </IconButton></Box>
          )
        },
        onExited: () => {
          setOpen(false)
        }
      });
    }
  }, [snackbarSetting])
  return (
    <></>
  )
}

const LBSnackbar = (props:SnackbarProps) => {
  const {configName, themeName, previewTheme} = props;
  const componentConfig = require(`./${configName || 'config'}.json`);
  const componentTheme = require(`./${themeName || 'theme'}.json`);
  const defaultTheme = createTheme(_.defaultsDeep(componentTheme,BasicTheme))
  const theme:any = createTheme(_.defaultsDeep({
    overrides: {}
  },previewTheme || defaultTheme));

  return (
    <SnackbarProviderCustom maxSnack={3} hideIconVariant={true}>
      <ThemeProvider<Theme> theme={theme}>
        <LBSnackbarContent config={componentConfig} {...props} ></LBSnackbarContent>
      </ThemeProvider>
    </SnackbarProviderCustom>
    
  )
}

export default LBSnackbar
